// extracted by mini-css-extract-plugin
module.exports = {"image":"Disclaimer_image__16Te7","contactInfo":"Disclaimer_contactInfo__3W_P0"};